export default theme => (
  {
    root: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 4
    },
    title: {
      fontSize: theme.typography.pxToRem(17)
    }
  }
)



// WEBPACK FOOTER //
// ./src/styles/components/member-benefit-card-header.js